export const REQUEST_UNRESPONDED_MESSAGE_COUNT = 'zola/couple/REQUEST_UNRESPONDED_MESSAGE_COUNT';
export const RECIEVED_UNRESPONDED_MESSAGE_COUNT = 'zola/couple/RECEIVED_UNRESPONDED_MESSAGE_COUNT';
export const REQUEST_INQUIRY_LIST = 'zola/couple/REQUEST_INQUIRY_LIST';
export const RECIEVED_INQUIRY_LIST = 'zola/couple/RECIEVED_INQUIRY_LIST ';
export interface ReceivedUnrespondedMessagesAction {
  type: typeof RECIEVED_UNRESPONDED_MESSAGE_COUNT;
  payload: number;
}

export interface RequestUnrespondedMessagesAction {
  type: typeof REQUEST_UNRESPONDED_MESSAGE_COUNT;
}

export interface ReceivedInquiryListAction {
  type: typeof RECIEVED_INQUIRY_LIST;
  payload: {
    inquiries: Record<string, unknown>[];
  };
}

export interface RequestInquiryListAction {
  type: typeof REQUEST_UNRESPONDED_MESSAGE_COUNT;
}

export type InquiryUnrespondedMessagesActionTypes =
  | ReceivedUnrespondedMessagesAction
  | RequestUnrespondedMessagesAction
  | ReceivedInquiryListAction
  | RequestInquiryListAction;
